import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import Button from '../../../../Button';
import { H4, Paragraph } from '../../../../Typography';

import styles from './PackageHeaderMeteredExperimentMobile.module.scss';

const PackageHeaderMeteredExperimentMobile = ({
  title,
  price,
  displayMonthlyPrice,
  onButtonClick,
  bestValue = false,
  preAppliedCoupon,
  className,
  buttonText,
}) => {
  const buttonLabel = buttonText || `GET ${title.toUpperCase()}`;

  const isPro = title === 'Pro';

  const getMonthlyPrice = () => {
    const monthlyPrice = (price / 12).toFixed(2);
    return `$${monthlyPrice}`;
  };

  return (
    <div className={cx(className, styles.packageHeaderMobile)}>
      {bestValue && <div className={styles.bestValueBanner}>Most Popular</div>}
      <div className={styles.headerContent}>
        <H4 className={styles.packageTitle}>{title}</H4>
        <div className={styles.priceContainer}>
          <Paragraph className={styles.price}>${price}</Paragraph>
          <Paragraph className={styles.paymentInterval}>PER YEAR</Paragraph>
          {displayMonthlyPrice && (
            <Paragraph className={styles.monthlyPrice}>
              {getMonthlyPrice()}/mo
            </Paragraph>
          )}
          {preAppliedCoupon && (
            <Paragraph className={styles.couponText}>
              {preAppliedCoupon.displayText}
            </Paragraph>
          )}
        </div>
        <Button
          className={styles.getButton}
          onClick={onButtonClick}
          secondary={!isPro}
        >
          {buttonLabel}
        </Button>
      </div>
    </div>
  );
};

PackageHeaderMeteredExperimentMobile.propTypes = {
  title: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  displayMonthlyPrice: PropTypes.bool,
  onButtonClick: PropTypes.func,
  bestValue: PropTypes.bool,
  preAppliedCoupon: PropTypes.object,
  className: PropTypes.string,
  buttonText: PropTypes.string,
};

export default PackageHeaderMeteredExperimentMobile;
